import React from 'react';
import PropTypes from 'prop-types';
import { AccordionContent, AccordionPadding, AccordionWrapper, ArrowImg, Heading, Title } from './styled';

const AccordionItem = ({
  dividerComp,
  handleTriggerClick,
  isFirst,
  margin,
  open,
  s3BasePath,
  title,
  children,
  itemPosition,
  iconPosition,
  isDesktop,
}) => {
  const arrowImgUrl = open
    ? `${s3BasePath}mkt/icon/triangle_down_black.png`
    : `${s3BasePath}mkt/icon/triangle_right_black.png`;
  return children ? (
    <AccordionWrapper data-cy={`filter-${title}`} margin={margin}>
      <Heading isFirst={isFirst} onClick={() => handleTriggerClick(itemPosition)} isDesktop={isDesktop}>
        {iconPosition === 'left' && <ArrowImg open={open} src={arrowImgUrl} isDesktop={isDesktop} />}
        <Title isDesktop={isDesktop}>{title || 'Description'}</Title>
        {iconPosition === 'right' && <ArrowImg open={open} src={arrowImgUrl} isDesktop={isDesktop} />}
      </Heading>
      <AccordionContent open={open} isDesktop={isDesktop}>
        <AccordionPadding isDesktop={isDesktop}>{children}</AccordionPadding>
      </AccordionContent>
      {dividerComp || null}
    </AccordionWrapper>
  ) : null;
};

AccordionItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  dividerComp: PropTypes.element,
  handleTriggerClick: PropTypes.func,
  iconPosition: PropTypes.string,
  isDesktop: PropTypes.bool,
  isFirst: PropTypes.bool,
  itemPosition: PropTypes.number,
  margin: PropTypes.string,
  open: PropTypes.bool,
  s3BasePath: PropTypes.string.isRequired,
  text: PropTypes.any,
  title: PropTypes.string,
};

export default AccordionItem;
